// src/components/BreadcrumbJsonLd.jsx
import React from 'react';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export default function BreadcrumbJsonLd({ list }) {
  // `list` is een array van { name, item } in volgorde van boven naar onder
  const itemListElement = list.map((node, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: node.name,
    item: node.item
  }));

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement
        })}
      </script>
    </Helmet>
  );
}
